import React, { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Education from "./components/Education";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Instagram from "./components/Instagram";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { Marquee, RouteHUD } from "./components/ui-bits";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-night p-8 text-center text-slate-300">
          <div>
            <p className="font-display text-2xl uppercase tracking-wide">Something slipped off the mountain.</p>
            <button className="mt-4 border border-ember px-5 py-2 font-mono text-[11px] tracking-[0.2em] text-ember" onClick={() => this.setState({ error: null })}>
              RETRY
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative min-h-screen overflow-x-clip bg-night font-body text-slate-100">
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Education />
          <Experience />
          <Skills />
          <Projects />
          <Services />
          <Testimonials />
          <Instagram />
          <Contact />
        </main>
        <Footer />
        <BackToTop />
        <RouteHUD />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
